module.exports = __webpack_public_path__ + "img/44.e687979b.jpg";